export async function downloadAsync(url, _hash, _type) {
    return url;
}
